import { WorkerRolActions } from '@admin/models';
import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { Cookies } from 'typescript-cookie';

interface ActionMap {
  [key: string]: string;
}

export const permissionsGuard: CanMatchFn = (route, segments) => {
  const router = inject(Router);

  const url = segments[1]?.path;

  const actions: WorkerRolActions[] = JSON.parse(
    localStorage.getItem('permissions')!
  );

  const actionMap: ActionMap = {
    parameter: 'parametro',
    country: 'pais',
    building: 'edificio',
    buildings: 'edificio',
    floor: 'nivel',
    floors: 'nivel',
    'workplace-type': 'tipo_puesto_trabajo',
    'editor-page': 'editor',
    'create-reservations': 'crear_reserva',
    'detail-page': 'ver_reserva',
    'view-parking': 'ver_parqueo',
    'workplace-group': 'grupo_puesto_trabajo',
    'worker-group': 'grupo_usuario',
    'worker-workplace-group': 'gestion_grupo',
    'place-report': 'reporte_lugares',
    'busier-hours-report': 'reporte_horarios',
    'reservation-report': 'reporte_reservas',
    actions: 'accion',
    roles: 'rol',
    workers: 'usuario',
    assignrole: 'asignar_rol',
    assignaction: 'asignar_accion',
    company: 'empresa',
    theme: 'tema',
    dashboard: 'dashboard',
  };

  const actionName = actionMap[url];

  if (Cookies.get('role') !== 'SYSADMIN' && actionName) {
    const item = actions.find(item => item.actionName === actionName);
    if (!item?.show) {
      router.navigateByUrl('/without-permission');
      return item!.show;
    }
  }

  return true;
};
